var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',{staticClass:"file"},[_c('figure',{staticClass:"file__icon",class:[("file__icon--" + _vm.fileType)]}),_vm._v(" "),_c('p',{staticClass:"file__name"},[_vm._v(_vm._s(_vm.fileName))])])}
var staticRenderFns = []

export { render, staticRenderFns }